import React, { Component, PropTypes } from 'react';


const splitIntoParagraphs = (content) => content.split(/\n\s*\n/g).map(line => `<p>${line}</p>`).join('');


export default class OrganizationDetailTextSection extends Component {

  constructor(props) {
    super(props);

    const { organization, orgAttr } = props;
    this.state  = {
      showEditBox: false,
      content: organization[orgAttr]
    };
  }

  showEditBox = e => {
    e.preventDefault();
    this.setState({ showEditBox: true });
  };

  hideEditBox = e => {
    e.preventDefault();
    this.setState({ showEditBox: false });
  };

  cancelEdit = e => {
    this.setState({ content: null });
    this.hideEditBox(e);
  };

  updateContent = e => {
    this.setState({ content: e.target.value });
  };

  saveContent = e => {
    e.preventDefault();
    this.props.updateContent(this.props.orgAttr, this.state.content);
    this.hideEditBox(e);
  };

  textareaRefName = () => {
    return `textarea${this.props.sectionTitle}`;
  };

  render() {
    const { organization, isEditMode, sectionTitle, orgAttr, cssSuffix } = this.props;
    const cssClass = `organizationDetail-${cssSuffix}`;
    const sectionContent = this.state.content || organization[orgAttr];

    if(!sectionContent) {
      return <span />;
    }

    let content = '';

    let editIcon = '';
    if(this.props.isEditMode) {
      editIcon = <span onClick={this.showEditBox} className="organization-editIcon">
        <i className="fa fa-pencil"></i>
      </span>;
    }

    function createMarkup(content) {
      return { __html: splitIntoParagraphs(content).split('\n').join('<br/>') };
    }

    if(this.state.showEditBox) {
      content = <span>
        <div className="">
          <button onClick={this.saveContent} className="button-primary">Save</button> &nbsp;
          <button onClick={this.cancelEdit} className="">Cancel</button>
        </div>
        <textarea className="organizationDetail-editableTextArea" onChange={this.updateContent} defaultValue={sectionContent} />
      </span>;
    }
    else {
      content = <div dangerouslySetInnerHTML={createMarkup(sectionContent)}></div>;
    }



    return  <div className={cssClass}>
      <div className={cssClass + 'Title'}>{sectionTitle.toLowerCase()} {editIcon} </div>
      <div className={cssClass + 'Description'}>{content}</div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailTextSection.jsx